import { useState } from 'react';
import Autosuggest from 'react-autosuggest';

interface Props {
  formData: any;
  setFormData: any;
  formValidations: any;
  setFormValidations: any;
  validating: boolean;
  countriesList: any;
  isNested?: boolean;
  sameAddressError?: any;
}

const AddressInput = ({
  formData,
  setFormData,
  formValidations,
  setFormValidations,
  validating,
  countriesList,
  sameAddressError,
  isNested,
}: Props) => {
  const [value, setValue] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  const [isSuggestionsOpen, setIsSuggestionsOpen] = useState(false);
  const [selectedFlag, setSelectedFlag] = useState('CA');
  const [isCountrySelectorOpen, setIsCountrySelectorOpen] = useState(false);
  const [addressVal, setAddressVal] = useState(
    isNested ? formData?.address?.address : formData?.address
  );

  const fetchData = async (inputValue: any, lastId: string) => {
    try {
      const apiKey = 'rn97-xb28-nt29-gm45';
      const apiUrl = `https://ws1.postescanada-canadapost.ca/AddressComplete/Interactive/Find/v2.10/json3ex.ws?Key=${apiKey}&Country=${selectedFlag}&SearchTerm=${inputValue}&LanguagePreference=en&LastId=${lastId}&SearchFor=Everything&OrderBy=UserLocation&$block=true&$cache=true`;

      const response = await fetch(apiUrl);
      const data = await response.json();

      if (data.Items) {
        setSuggestions(
          data.Items.map((item: any) => ({
            label:
              item?.Description !== ''
                ? ` ${item?.Text}, ${item?.Description}`
                : item?.Text,
            value: item.Id,
            next: item?.Next,
            text: item?.Text,
          }))
        );
      } else {
        setSuggestions([]);
      }
    } catch (error) {
      console.error('Error fetching suggestions:', error);
    }
  };

  const fetchDetail = async (id: any) => {
    try {
      const apiKey = 'rn97-xb28-nt29-gm45';
      const apiUrl = `https://ws1.postescanada-canadapost.ca/AddressComplete/Interactive/RetrieveFormatted/v2.10/json3ex.ws?Key=${apiKey}&Id=${id}&LanguagePreference=en&`;

      const response = await fetch(apiUrl);
      const data = await response.json();
      let item = data.Items[0];
      if (isNested) {
        setFormData({
          ...formData,
          address: {
            ...formData.address,
            address: item?.Line1,
            city: item?.City,
            country: item?.CountryIso2,
            province: item?.ProvinceCode,
            postal_code: item?.PostalCode,
          },
        });
      } else {
        setFormData({
          ...formData,
          address: item?.Line1,
          city: item?.City,
          country: item?.CountryIso2,
          province: item?.ProvinceCode,
          postal_code: item?.PostalCode,
        });
      }
      setFormValidations({
        ...formValidations,
        address: item?.Line1 !== '',
        city: item?.City !== '',
        country: item?.CountryIso2 !== '',
        province: item?.ProvinceCode !== '',
        postal_code: item?.PostalCode !== '',
      });
    } catch (error) {
      console.error('Error fetching suggestions:', error);
    }
  };

  const onSuggestionsFetchRequested = ({ value }: any) => {
    fetchData(value, '');
    setIsSuggestionsOpen(true);
  };

  const onSuggestionsClearRequested = () => {
    setSuggestions([]);
    setIsSuggestionsOpen(false);
  };

  const onSuggestionSelected = (event: any, { suggestion, method }: any) => {
    if (suggestion.next !== 'Find') {
      fetchDetail(suggestion.value);
    }
  };

  const getSuggestionValue = (suggestion: any) => {
    if (suggestion.next !== 'Find') {
      return suggestion.label;
    } else {
      fetchData(suggestion?.text, suggestion?.value);
      setIsSuggestionsOpen(true);
      return '';
    }
  };

  const renderSuggestion = (suggestion: any) => {
    if (!suggestion || !suggestion.label) {
      return null;
    }
    return (
      <div>
        {suggestion?.label}
        {suggestion?.next === 'Find' && (
          <span
            style={{
              cursor: 'pointer',
              marginLeft: '10px',
              color: 'blue',
              float: 'right',
            }}
            onClick={() => {}}
          >
            <img
              src={
                'https://ws1.postescanada-canadapost.ca/images/icons/captureplus/chevron.png'
              }
              alt=''
            />
          </span>
        )}
      </div>
    );
  };

  const CountrySelector = ({ countries, onSelect }: any) => {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
        }}
        className='autosuggest-container'
      >
        {countries.map((country: any) => (
          <div
            key={country.country_code}
            style={{
              display: 'flex',
              alignItems: 'center',
            }}
            className='suggestion'
            onClick={() => onSelect(country)}
          >
            <img
              style={{ height: 15, width: 15, marginRight: '5px' }}
              src={`https://purecatamphetamine.github.io/country-flag-icons/3x2/${country.code}.svg`}
              alt=''
            />
            {country.name}
          </div>
        ))}
      </div>
    );
  };

  const toggleCountrySelector = () => {
    setIsCountrySelectorOpen(!isCountrySelectorOpen);
  };

  const renderFooter = () => (
    <div
      style={{
        display: isSuggestionsOpen ? 'block' : 'none',
      }}
      className='country-border'
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
        }}
      >
        <div className='change-country' onClick={toggleCountrySelector}>
          Change Country
        </div>
        <img
          style={{ height: 15, width: 15, cursor: 'pointer' }}
          src={`https://purecatamphetamine.github.io/country-flag-icons/3x2/${selectedFlag}.svg`}
          alt=''
          onClick={toggleCountrySelector}
        />
      </div>
      {isCountrySelectorOpen && (
        <CountrySelector
          countries={countriesList}
          onSelect={(country: any) => {
            setSelectedFlag(country.code);
            setIsCountrySelectorOpen(false);
          }}
        />
      )}
      <div
        className='aclogo pcalogoen'
        title='www.canadapost-postescanada.ca/ac'
        style={{}}
      ></div>
    </div>
  );

  const inputProps = {
    placeholder: '123 Address Road',
    value: isNested
      ? (formData?.address?.address || '').slice(0, 30)
      : (formData?.address || '').slice(0, 30),
    onChange: (_: any, { newValue }: any) => {
      let truncatedValue = newValue.slice(0, 30); // Truncate input to 30 characters
      if (isNested) {
        setFormData({
          ...formData,
          address: {
            ...formData.address,
            address: truncatedValue,
          },
        });
      } else {
        setFormData({
          ...formData,
          address: truncatedValue,
        });
      }
      setFormValidations({
        ...formValidations,
        address: truncatedValue !== '', // Validate truncated value
      });
      setValue(truncatedValue);
    },
    onFocus: () => {
      onSuggestionsFetchRequested({ value });
    },
  };

  const theme = {
    container: `autosuggest-container`,
    suggestionsContainer: 'suggestions-container',
    suggestionsList: 'suggestions-list',
    suggestion: 'suggestion',
    input: `${
      validating && (addressVal === '' || sameAddressError)
        ? 'is-invalid'
        : validating && addressVal !== ''
        ? 'is-valid'
        : ''
    }  ${
      inputProps.value !== '' ? 'custom-select-selected' : ''
    }  form-control ubbe-input`,
  };

  return (
    <Autosuggest
      suggestions={suggestions}
      onSuggestionsFetchRequested={onSuggestionsFetchRequested}
      onSuggestionsClearRequested={onSuggestionsClearRequested}
      onSuggestionSelected={onSuggestionSelected}
      getSuggestionValue={getSuggestionValue}
      renderSuggestion={renderSuggestion}
      inputProps={inputProps}
      theme={theme}
      shouldRenderSuggestions={() => true}
      renderSuggestionsContainer={({ containerProps, children, query }) => {
        return (
          <div {...containerProps}>
            {children}
            {renderFooter()}
          </div>
        );
      }}
    />
  );
};

export default AddressInput;
